import React from 'react';
import { Edit, Trash2, User } from 'lucide-react';
import EmptyState from '../Common/EmptyState';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const PersonTable = ({ persons, isLoading, onEdit, onDelete, resolveDocument, resolvePersonType, onCreate }) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!persons?.length) {
    return (
      <EmptyState
        icon={User}
        title="Nenhuma pessoa encontrada"
        description="Cadastre uma nova pessoa ou altere os filtros de busca."
        action={
          onCreate ? (
            <button type="button" className="btn btn-primary" onClick={onCreate}>
              Nova pessoa
            </button>
          ) : null
        }
      />
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Nome
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Documento
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Tipo
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Ações
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {persons.map((person) => (
            <tr key={person.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm font-medium text-gray-900">
                  {person.name}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900">
                  {resolveDocument ? resolveDocument(person) : (person.document || person.cpf || person.cnpj || '')}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                  resolvePersonType ? resolvePersonType(person) === 'individual' 
                    ? 'bg-primary-100 text-primary-700' 
                    : 'bg-info-100 text-info-700'
                    : person.type === 'INDIVIDUAL' 
                    ? 'bg-primary-100 text-primary-700' 
                    : 'bg-info-100 text-info-700'
                }`}>
                  {resolvePersonType ? 
                    (resolvePersonType(person) === 'individual' ? 'Pessoa Física' : 'Pessoa Jurídica') :
                    (person.type === 'INDIVIDUAL' ? 'Pessoa Física' : 'Pessoa Jurídica')
                  }
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                  person.is_active === true 
                    ? 'bg-success-100 text-success-700' 
                    : 'bg-gray-100 text-gray-700'
                }`}>
                  {person.is_active === true ? 'Ativo' : 'Inativo'}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <Can permission={P.IDENTITY_ACCESS}>
                  <div className="flex justify-end gap-2">
                    <button
                      type="button"
                      onClick={() => onEdit(person)}
                      className="text-primary-600 hover:text-primary-900"
                    >
                      <Edit className="w-4 h-4" />
                    </button>
                    <button
                      type="button"
                      onClick={() => onDelete(person.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </Can>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PersonTable;
